import React from 'react'

const LegalStyleDiv = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
    >
      {children}
    </div>
  )
}

export default LegalStyleDiv
